/**
 * @fileoverview POST handler for the "/apps/:app_id/fsa_credential" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsAppIdFirebaseCredentialCacheKeys } from "./constants";
import type { PostAppsAppIdUploadFirebaseCredentialProps } from "./types";

export const postAppsAppIdFirebaseCredential = reactQueryMutationAdapter(
  appsAppIdFirebaseCredentialCacheKeys,
  (props: PostAppsAppIdUploadFirebaseCredentialProps): Promise<{}> => {
    return fetch(
      `/apps/${props.appId}/fsa_credential`,
      "POST",
      {},
      { body: props.formData },
      { setContentType: false, propagateFetchRequestError: false }
    );
  }
);
